import React from 'react';
import { descricaoDoAnimal } from '../../../utils/animais';

/**
 * Como um animal aparece na lista de busca: nome em cima, raça e RGD embaixo.
 *
 * Serve doadora e touro, que são a mesma tabela e o mesmo problema — dois
 * animais de mesmo nome, e nada na lista para separá-los.
 *
 * Existe como componente porque a mesma lista é montada em sete lugares, e
 * eles já tinham divergido: a FIV mostrava o RGD da doadora, a OPU e a TE não;
 * as listas de touro mostravam a categoria, que numa lista de touros é "Touro"
 * em toda linha. Quem escolhia via coisas diferentes dependendo da aba.
 */
const IdentidadeDoAnimal = ({ animal, className = '' }) => (
  <>
    <div className="font-medium">{animal.identifier}</div>
    {/* `className` só ajusta o tamanho: no mobile a lista é maior e a segunda
        linha precisa continuar discreta. O conteúdo é o mesmo em toda tela. */}
    <div className={`text-slate-500 ${className}`}>{descricaoDoAnimal(animal)}</div>
  </>
);

export default IdentidadeDoAnimal;
